<template>
    <div class="page amount-rule">

        <div class="amount-rule-header">
            <div class="amount-rule-header-title">
                做任务赚博贝
                <div class="amount-rule-header-btn">
                    <van-button color="#0FB7AD" round size="small" @click="$router.push({name:'home'})">
                        去做任务
                    </van-button>
                </div>
            </div>
        </div>
        <div class="clear"></div>

        <div class="amount-rule-content">
            <van-cell is-link icon="/static/img/my/icon_mycenter_rule_login.svg">
                <template slot="title">
                    <div class="amount-rule-content-title">完成注册</div>
                    <div class="amount-rule-content-time">完成注册成为认证用户。</div>
                </template>
                <template slot="right-icon">
                    <div class="amount-rule-content-point">+{{register}}博贝</div>
                </template>
            </van-cell>
            <van-cell is-link icon="/static/img/my/icon_mycenter_rule_watch.svg">
                <template slot="title">
                    <div class="amount-rule-content-title">观看课程、直播、文章</div>
                    <div class="amount-rule-content-time">观看课程、直播、文章，同一页面只记录首次访问。</div>
                </template>
                <template slot="right-icon">
                    <div class="amount-rule-content-point">+{{view}}博贝</div>
                </template>
            </van-cell>
            <van-cell is-link icon="/static/img/my/icon_mycenter_rule_text.svg">
                <template slot="title">
                    <div class="amount-rule-content-title">发布评论</div>
                    <div class="amount-rule-content-time">对同一课程、文章只记录首次评论。</div>
                </template>
                <template slot="right-icon">
                    <div class="amount-rule-content-point">+{{comment}}博贝</div>
                </template>
            </van-cell>
            <van-cell is-link icon="/static/img/my/icon_mycenter_rule_share.svg">
                <template slot="title">
                    <div class="amount-rule-content-title">转发课程、直播、文章</div>
                    <div class="amount-rule-content-time">对同一课程、直播、文章只记录首次转发。</div>
                </template>
                <template slot="right-icon">
                    <div class="amount-rule-content-point">+{{share}}博贝</div>
                </template>
            </van-cell>
        </div>

    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                income:[],
                outcome:[],
                rule:[],
                register:0,
                view:0,
                comment:0,
                share:0,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'amount-rule') {
                    Interface.getData('get',Interface.amount_rule).then((res)=>{
                        this.register = res.data[0].value
                        this.view = res.data[1].value
                        this.comment = res.data[2].value
                        this.share = res.data[3].value
                    })
                }
            }
        },
        created() {
            this.fetch('amount-rule')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/amount-rule/index.vue